export default "__VITE_ASSET__Nzwqq9Hi__"